import "../external/typed/typed.jquery";

function Shuffle(o) {
  for (
    var j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o;
}

export default class Header {
  constructor(el) {
    this.el = el;
    this.document = $(document);
    this.searchOpen = false;
    this.menuOpen = false;
    this.searchBtn = this.el.find(".main-header__searchitem > a");

    this.icons = this.el.find(".main-header__icons li:not(.active)");
    this.iconsL = this.el.find(".main-header__icons li").length;
    this.hamburger = this.el.find(".main-header__hamburger");
    this.newsletterBtn = this.el.find("li.main-header__newsletter");
    this.events();
  }

  events() {
    this.stickyToggle();
    this.search();
    this.menu();
    this.iconTimer();
    //this.newsletterBtnClick();
  }

  //   newsletterBtnClick() {
  //     this.newsletterBtn.on("click", (evt) => {
  //       $("li.main-header__newsletter .main-header__cta__anchor").hide();
  //       $("li.main-header__newsletter .main-footer__subscription").show();
  //     });
  //   }
  stickyToggle() {
    $(window)
      .on("scroll", () =>
        this.el.toggleClass("main-header--sticky", $(window).scrollTop() > 25)
      )
      .trigger("scroll");
  }

  menu() {
    this.hamburger.on("click", () => this.toggleMenu());
  }

  toggleMenu() {
    if (this.searchOpen) {
      this.closeSearch();
    }

    if (this.menuOpen) {
      this.menuOpen = false;

      this.el.removeClass("main-header--mobilemenuopen");
    } else {
      this.menuOpen = true;

      this.el.addClass("main-header--mobilemenuopen");
    }
  }

  closeMenu() {
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  search() {
    this.searchBtn.on("click", (evt) => this.toggleSearch());

    this.document.on("click", (evt) => {
      if ($(evt.target).closest(".main-header").length === 0) {
        this.closeSearch();
      }
    });

    this.autocompleteSearch(
      $(".main-header__search input.main-header__search__input")
    );
    this.autocompleteSearch(
      $(".page__header__searchwrap input.page__header__searchinput")
    );
  }

  toggleSearch() {
    if (this.menuOpen) {
      this.closeMenu();
    }

    if (this.searchOpen) {
      this.searchOpen = false;

      this.el.removeClass("main-header--searchopen");
    } else {
      this.searchOpen = true;

      this.el.addClass("main-header--searchopen");

      setTimeout((e) => {
        this.el.find("#search").focus();
      }, 300);
    }
  }

  closeSearch() {
    if (this.searchOpen) {
      this.toggleSearch();
    }
  }

  autocompleteSearch(element) {
    const searchInput = element;
    const keywords = [
      "Try: Exhibition",
      "Try: Downtown Design",
      "Try: Talks",
      "Try: Workshop",
    ];
    Shuffle(keywords);

    searchInput.typed({
      strings: keywords,
      typeSpeed: 0,
      backDelay: 1000,
      loop: true,
    });
    searchInput.bind("mouseenter", function () {
      searchInput.data("typed").pauseTyping();
    });
    searchInput.bind("mouseleave focusout", function () {
      if (searchInput.val().length != 0) {
        //do nothing
      } else {
        searchInput.data("typed").continueTyping();
      }
    });
  }

  iconTimer() {
    const elmnt = document.querySelectorAll(".main-header__icons li");
    const numberOfelmnt = document.querySelectorAll(".main-header__icons li")
      .length;
    const activeClass = "active";

    const repeat = (
      numberOfIterations,
      timeBetweenItereation,
      stuffToRepeat
    ) => {
      let iterationCounter = 0;
      const repeater = () => {
        setTimeout(() => {
          stuffToRepeat(elmnt[iterationCounter], activeClass);
          iterationCounter++;
          if (numberOfIterations === iterationCounter) {
            iterationCounter = 0;
          }
          if (iterationCounter >= numberOfIterations) {
            return;
          }
          repeater();
        }, 1000 * timeBetweenItereation);
      };
      repeater();
    };

    const addClassToElmnt = (elmnt, className) => {
      let elmntWithClassToRemove = document.querySelectorAll(
        ".main-header__icons li.active"
      );

      [...elmntWithClassToRemove].forEach((curentElmnt) => {
        curentElmnt.classList.remove(className);
      });

      elmnt.classList.add(className);
    };

    repeat(numberOfelmnt, 2, addClassToElmnt);
  }
}
